<template>
  <main class="activities">
    <h1 class="hide--visually">Activities</h1>

    <section class="activities-nav activities-nav--no-desktop">
      <activities-nav></activities-nav>
    </section>

    <section class="sidebar sidebar--integrations">
      <div class="sidebar-track sidebar-track--integrations iscroll" id="integrations">
        <div class="sidebar-wrap">
          <template v-if="platform">
            <ul class="sidebar__list sidebar__list--platform">
              <li class="sidebar__item"
                :class="{'sidebar__item--active': activeIntegration == platform}"
              >
                <i class="sidebar-platform__indicator"></i>
                <button type="button" class="sidebar__integration"
                  @click.prevent="filter('integrations', platform); navigationController(null, $event)"
                >
                  <i class="integration__icon" :class="'integration__icon--' + slugify(platform)"></i>
                  <span class="sidebar__name">{{ platform }}</span>
                </button>
                <!--
                <span class="sidebar__options">
                  <span class="sidebar__count">4</span>
                </span>
                -->
              </li>
            </ul>
          </template>

          <template v-if="integrations">
            <h2 class="sidebar__title">
              <span class="sidebar__title-wrap">Integrations</span>
            </h2>

            <ul class="sidebar__list sidebar__list--integrations">
              <li class="sidebar__item"
                v-for="integration in integrations"
                :class="{'sidebar__item--active': activeIntegration == integration.name}"
                :key="integration.name"
              >
                <i class="sidebar-platform__indicator"></i>
                <button type="button" class="sidebar__integration"
                  @click.prevent="filter('integrations', integration.name); navigationController(null, $event)"
                >
                  <i class="integration__icon" :class="'integration__icon--' + slugify(integration.name)"></i>
                  <span class="sidebar__name">{{ integration.name }}</span>
                </button>
                <span class="sidebar__options" :class="{ 'sidebar__options--active': integration.connected && integration.is_setup }">
                  <a type="button" class="sidebar__connect"
                    v-if="!integration.connected"
                    :href="integration._links.authorize_url.href"
                  >Connect</a>
                  <button type="button" class="sidebar__connect"
                    v-if="integration.connected && !integration.is_setup"
                    @click.prevent="setupIntegration(integration)"
                  >Setup</button>
                  <!-- <span class="sidebar__count">3</span> -->
                </span>
              </li>
            </ul>
          </template>

          <button type="button" class="sidebar__button"
            @click.prevent="toggleClass('integrations-overlay-active', 'integrations-overlay-transition', 500)"
          >Add / Edit Integrations</button>
        </div>
      </div>
    </section>

    <section class="activities-content">
      <section class="activities-filters">

        <div class="activities-columns">

          <div class="activities-column activities-column--integrations">
            <button type="button" class="activities-integrations__button icon--chevron-left" title="Integrations Menu"
              @click.prevent="navigationController('integrations', $event)"
            >
              <span class="hide--visually">Integrations Menu</span>
            </button>
          </div>

          <div class="activities-column activities-column--breadcrumbs">
            <ul class="activities-breadcrumbs">
              <li class="activities-breadcrumbs__item">
                <button type="button" class="activities-breadcrumbs__button"
                  @click.prevent="filter('integrations')"
                >All</button>
              </li>
              <li class="activities-breadcrumbs__item"
                :class="{'activities-breadcrumbs__item--active' : activeIntegration}"
              >
                <button type="button" class="activities-breadcrumbs__button">{{ activeIntegration }}</button>
              </li>
            </ul>
          </div>

          <div class="activities-column activities-column--search">
            <button type="button" class="activities-search__open icon--search" title="Search"
              @click.prevent="toggleSearch()"
            >
              <span class="hide--visually">Search</span>
            </button>
          </div>

          <div class="activities-column activities-column--favorites">
            <button type="button" class="activities-toggle-favorites"
              @click.prevent="filter('pins')"
            >
              <span class="activities-toggle-favorites__track"></span>
              <span class="activities-toggle-favorites__toggle icon--favorite"
                :class="{'activities-toggle-favorites__toggle--active': activePin}"
              ></span>
              <span class="hide--visually">favorites</span>
            </button>
          </div>

          <div class="activities-column activities-column--search-overlay">
            <div class="activities-search">
              <input type="text" class="activities-search__input" placeholder="Search..." v-model="search" @keyup="searchDebounce()">
              <button type="button" class="activities-search__close icon--close" title="Close"
                @click.prevent="toggleSearch()"
              >
                <span class="hide--visually">Close</span>
              </button>
            </div>
          </div>
        </div>

        <a href="#" class="activities-new-messages__link"
          :class="{'activities-new-messages__link--active' : resultsNew.length > 0 }"
          @click.prevent="insertNewActivities(true)"
        >
          <template
            v-if="resultsNew.length > 0"
          >
            <strong>{{ resultsNew.length }}</strong> new {{ 'message' | pluralize(resultsNew.length) }}
          </template>
        </a>
      </section>

      <section class="activities-messages">
        <div class="activities-messages-wrap">
          <template v-if="activities">
            <template v-for="(groupedActivities, key) in activities">
              <template if="key">
                <aside class="activities-header"
                  :class="$firefox ? '' : 'scrollmagic__fade-in-up'"
                  :key="key"
                >
                  <p class="activities-header__title">{{ headerDate(key) }}</p>
                  <time class="activities-header__date">{{ dateFormat(key, 'MMMM DD, YYYY') }}</time>
                </aside>
              </template>

              <template v-for="activity in groupedActivities">
                <activity-message
                  :activity="activity"
                  :key="activity.id"
                  @pinActivity="pinActivity"
                ></activity-message>
              </template>
            </template>

            <template v-if="filterAlert">
              <div class="activities-no-results"
                :class="$firefox ? '' : 'scrollmagic__fade-in-up'"
              >
                <i class="activities-no-results__icon"></i>
                <h2 class="activities-no-results__title">No results found</h2>
                <p class="activities-no-results__info">Try adjusting your search to find what you're looking for.</p>
              </div>
            </template>
          </template>

          <template v-else>
            <section class="activities-loader">Loading...</section>
          </template>
        </div>
      </section>
    </section>

    <aside class="sidebar sidebar--realtime">
      <section class="activities-nav activities-nav--desktop">
        <activities-nav
          :desktop="true"
        ></activities-nav>
      </section>

      <!-- Real Time -->
      <section class="sidebar-track sidebar-track--realtime iscroll" id="realtime">
        <real-time-sidebar
          @updateIScroll="iScrollUpdate"
        ></real-time-sidebar>
      </section>

      <!-- Today -->
      <section class="sidebar-track sidebar-track--today iscroll" id="today">
        <today-sidebar
          @updateIScroll="iScrollUpdate"
        ></today-sidebar>
      </section>
    </aside>

    <!-- Integrations Overlay -->
    <aside class="integrations-overlay">
      <header class="integrations-overlay-header">
        <h1 class="integrations-overlay__title">Integrations</h1>
        <button type="button" class="integrations-overlay__close"
          @click.prevent="toggleClass('integrations-overlay-active', 'integrations-overlay-transition', 500)"
        >Close</button>
      </header>

      <div class="integrations-overlay-content">
        <ul class="integrations-overlay__list">
          <li class="integrations-overlay__item">
            <h2 class="integrations-overlay__subtitle">
              <i class="integration__icon integration__icon--shopify"></i>
              <span class="integrations-overlay__name">Shopify</span>
            </h2>

            <div class="integrations-overlay__description">
              <p>Keep track of your online orders.</p>
            </div>

            <div class="integrations-overlay__base">
              <small class="integrations-overlay__type">Ecommerce</small>
              <span class="integrations-overlay-buttons">
                <!-- <button class="integrations-overlay__button"></button> -->
              </span>
            </div>
          </li>

          <li class="integrations-overlay__item"
            v-for="integration in integrations"
            :key="integration.name"
          >
            <h2 class="integrations-overlay__subtitle">
              <i class="integration__icon"
                :class="'integration__icon--' + slugify(integration.name)"
              ></i>
              <span class="integrations-overlay__name">{{ integration.name }}</span>
            </h2>

            <div class="integrations-overlay__description">
              <p>{{ integration.description }}</p>
            </div>

            <div class="integrations-overlay__base">
              <small class="integrations-overlay__type">{{ integration.type }}</small>
              <span class="integrations-overlay-buttons">
                <a class="integrations-overlay__button"
                  :class="!integration.connected ? 'integrations-overlay__button--active' : ''"
                  :title="!integration.connected ? 'Connect' : 'Connected!'"
                  :href="integration._links.authorize_url.href"
                ></a>
                <a class="integrations-overlay__button integrations-overlay__button--remove" href="#"
                  v-if="integration.connected"
                  :title="'Remove'"
                  @click.prevent="removeIntegration(integration)"
                ></a>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </aside>

    <!-- Activity Overlay -->
    <aside class="activity-overlay">
      <header class="activity-overlay-header">
        <h1 class="activity-overlay__title">Activity</h1>
        <button type="button" class="activity-overlay__close"
          @click.prevent="closeActivity()"
        >Close</button>
      </header>

      <div class="activity-overlay-content">
        <activity-message
          v-if="activityDetail"
          :activity="activityDetail"
          @pinActivity="pinActivity"
        ></activity-message>
      </div>
    </aside>

    <connect
      :integration="integration"
    ></connect>

    <button type="button" class="sidebar-overlay" @click.prevent="navigationController(null, $event)">Close</button>
  </main>
</template>

<script>
  import Activity from '@/components/Activity'
  import Connect from '@/components/Connect'
  import RealTimeSidebar from '@/components/RealTimeSidebar'
  import TodaySidebar from '@/components/TodaySidebar'

  import { ga } from '@/mixins/ga.js'
  import { helpers } from '@/mixins/helpers.js'
  import { refresh } from '@/mixins/refresh.js'

  import axios from 'axios'
  import _debounce from 'lodash/debounce'
  import _filter from 'lodash/filter'
  import _find from 'lodash/find'
  import _groupBy from 'lodash/groupBy'
  import _sortBy from 'lodash/sortBy'
  import IScroll from 'iscroll/build/iscroll-probe'
  import moment from 'moment'
  import swal from 'sweetalert'
  import Velocity from 'velocity-animate'
  import Vue from 'vue'

  Vue.component('activities-nav', {
    template: `
      <ul class="activities-nav__list">
        <li class="activities-nav__item activities-nav__item--activity"
          :class="{'activities-nav__item--active': $parent.navigationActive === null}"
        >
          <button type="button" class="activities-nav__button"
            @click.prevent="navigationController(null, $event)"
          >
            <span>Activity</span>
          </button>
        </li>
        <li class="activities-nav__item activities-nav__item--realtime"
          :class="{'activities-nav__item--active': $parent.navigationActive === 'realtime' ||
            ($parent.navigationActive === null && desktop === true)}"
        >
          <button type="button" class="activities-nav__button"
            @click.prevent="navigationController('realtime', $event)"
          >
            <span>Real-Time</span>
          </button>
        </li>
        <li class="activities-nav__item activities-nav__item--today"
          :class="{'activities-nav__item--active': $parent.navigationActive === 'today'}"
        >
          <button type="button" class="activities-nav__button"
            @click.prevent="navigationController('today', $event)"
          >
            <span>Today</span>
          </button>
        </li>
        <li class="activities-nav__item activities-nav__item--view">
          <!--<button type="button" class="activities-nav__view icon--edit"
            @click.prevent=""
          >-->
            <span class="hide--visually">View</span>
          </button>
        </li>
      </ul>
    `,
    props: {
      desktop: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      navigationController (className, e) {
        this.$parent.navigationController(className, e)
      }
    }
  })

  export default {
    name: 'activities',
    components: {
      'activity-message': Activity,
      'connect': Connect,
      'real-time-sidebar': RealTimeSidebar,
      'today-sidebar': TodaySidebar
    },
    mixins: [ga, helpers, refresh],
    data () {
      return {
        activityDetail: null,
        activeIntegration: null,
        activePin: false,
        activities: null,
        activitiesLastLoad: moment(),
        activitiesNextPage: null,
        activitiesUrl: `${this.$domain}/activities`,
        bottom: false,
        filterAlert: false,
        iscroll: [],
        integration: null,
        integrations: [],
        navigationActive: null,
        platform: '',
        results: [],
        resultsNew: [],
        refresh_method: 'loadNewActivity',
        refresh_time: 15000,
        scrollMagicProgress: null,
        search: null,
        searchActiveClass: 'search-active'
      }
    },
    methods: {
      closeActivity () {
        this.toggleClass('activity-overlay-active', 'activity-overlay-transition', 500)
        this.$router.push({name: 'Activities'})
      },
      filter (type, name = null) {
        let activities = this.results
        this.scrollMagicFadeInDestroy()

        // Set active integration
        if (type === 'integrations') {
          this.activeIntegration = name !== this.activeIntegration ? name : null
        // Toggle pinning active
        } else if (type === 'pins') {
          this.activePin = !this.activePin
        }

        // Filter by active integration/platform
        if (this.activeIntegration) {
          activities = _filter(activities, ['platform', this.activeIntegration])
        }

        // Filter by pinned
        if (this.activePin) {
          activities = _filter(activities, 'saved')
        }

        // Filter by search term
        if (this.search) {
          activities = _filter(activities, (obj) => {
            let fields = [obj.title, obj.description, obj.level]
            return fields.join().toLowerCase().includes(this.search.toLowerCase())
          })
        }

        this.groupByDate(activities)

        this.$nextTick(() => {
          this.scrollToTop()
        })
      },
      filterReset () {
        this.activeIntegration = null
        this.activePin = false
        this.toggleSearchVisible(false, false)
        this.filter(null)
      },
      groupByDate (activities) {
        let html = document.querySelector('html')

        if (this.$firefox === false) {
          html.classList.add('scrollmagic-loading')
        }

        this.activities = _groupBy(activities, (obj) => {
          return moment(obj.created).format('YYYY-MM-DD')
        })

        if (Object.keys(this.activities).length >= 1) {
          this.filterAlert = false
        } else {
          this.filterAlert = true
        }

        if (this.$firefox === false) {
          this.$nextTick(() => {
            this.scrollMagicFadeInUpdate()
            setTimeout(() => { html.classList.remove('scrollmagic-loading') }, 500)
          })
        }
      },
      insertNewActivities (force = false) {
        if (force) {
          this.filterReset()
        } else if (window.scrollY > 0) {
          return false
        }

        if (this.resultsNew.length > 0) {
          this.results = [...this.resultsNew, ...this.results]
          this.resultsNew = []
          this.groupByDate(this.results)
        }
      },
      iScroll () {
        let elements = document.querySelectorAll('.iscroll')
        let iscroll = this.iscroll

        setTimeout(() => {
          for (let element of elements) {
            let id = element.id

            if (iscroll.indexOf(id) === -1) {
              iscroll.push(id)
              iscroll[id] = new IScroll('#' + id, {
                mouseWheel: true,
                probeType: 3
              })
            }

            iscroll[id].refresh()

            if (id === 'today') {
              iscroll[id].on('scroll', () => {
                // let iscrollTop = iscroll[id].y
                let todayButton = document.querySelector('.activities-today-button')
                if (todayButton !== null) {
                  let todayButtonTop = todayButton.getBoundingClientRect().top
                  let windowHeight = window.innerHeight || document.body.clientHeight
                  if (todayButtonTop <= windowHeight && todayButton.classList.contains('scrollmagic__today-fade-in-up')) {
                    todayButton.classList.add('scrollmagic__today-fade-in-up--show')

                    setTimeout(() => {
                      todayButton.classList.remove('scrollmagic__today-fade-in-up', 'scrollmagic__today-fade-in-up--show')
                    }, 500)
                  }
                }
              })
            }
          }
        }, 500)

        // Resize
        window.addEventListener('resize', () => {
          for (let id of iscroll) {
            iscroll[id].refresh()
          }
        })
      },
      iScrollUpdate () {
        setTimeout(() => { this.triggerWindowResize() }, 500)
      },
      loadActivity (id) {
        let that = this

        this.toggleClass('activity-overlay-active', 'activity-overlay-transition', 500)

        return axios({
          url: `${that.activitiesUrl}/${id}`
        })
        .then((response) => {
          that.activityDetail = response.data
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadData () {
        let that = this
        let url = that.activitiesNextPage !== null ? that.activitiesNextPage : that.activitiesUrl

        that.$Progress.start()

        return axios({
          url: url
        })
        .then((response) => {
          let data = response.data

          if (that.activitiesNextPage !== null) {
            that.results = [...that.results, ...data.activities]
          } else {
            that.results = data.activities
          }

          that.groupByDate(that.results)
          that.$Progress.finish()
          that.activitiesNextPage = data.pagination._links.next_page.href
        })
        .catch((error) => {
          console.log(error)
          that.$Progress.fail()
        })
      },
      loadIntegrations () {
        let that = this

        return axios({
          url: `${this.$domain}/integrations`
        })
        .then((response) => {
          that.integrations = _sortBy(response.data.integrations, [(obj) => {
            if (obj.name === 'Google Analytics') {
              return 0
            }
            return 1
          }, 'name'])

          let name = that.$route.query.setup
          if (name) {
            let integration = _find(that.integrations, ['name', name])
            if (integration) {
              that.setupIntegration(integration)
            }
          }

          // For Real-Time/Today component placeholders
          let googleIntegrated = _find(response.data.integrations, ['name', 'Google Analytics']).is_setup
          this.$emit('googleIntegrated', googleIntegrated)
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadNewActivity () {
        let that = this
        let now = moment()
        let params = {
          start: encodeURI(that.activitiesLastLoad.format()),
          end: encodeURI(now.format())
        }

        that.activitiesLastLoad = now

        return axios({
          url: that.activitiesUrl,
          params: params
        })
        .then((response) => {
          let data = response.data
          that.resultsNew = [...data.activities, ...that.resultsNew]
          that.insertNewActivities()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      navigationController (className, e) {
        let activeClasses = ['integrations', 'realtime', 'today']
        let html = document.querySelector('html')

        if (className !== undefined) {
          this.navigationActive = className
        }

        let removeActive = (el) => {
          if (this.getBreakpoint() < 1200) {
            html.classList.add(el + '-transition')
            html.classList.remove(el + '-active')
            setTimeout(() => { html.classList.remove(el + '-transition') }, 500)
          } else {
            if (e !== undefined && !e.currentTarget.hasAttribute('data-name')) {
              html.classList.add(el + '-transition')
              html.classList.remove(el + '-active')
              setTimeout(() => { html.classList.remove(el + '-transition') }, 500)
            }
          }
        }

        let toggleActive = (el) => {
          html.classList.add(el + '-transition')
          html.classList.toggle(el + '-active')
          setTimeout(() => { html.classList.remove(el + '-transition') }, 500)
        }

        if (e !== undefined && e.type === 'click') { // Click
          if (className === null) { // Close html active
            for (let el of activeClasses) {
              if (document.querySelector('html').classList.contains(el + '-active')) {
                removeActive(el)
              }
            }
          } else { // Toggle active
            for (let el of activeClasses) { // Remove all other html active
              if (document.querySelector('html').classList.contains(el + '-active')) {
                if (el !== className) {
                  removeActive(el)
                }
              }
            }

            toggleActive(className) // Toggle html active

            this.triggerWindowResize()
          }
        }
      },
      pageBottom () {
        let pageHeight = document.documentElement.scrollHeight
        let scrollY = window.scrollY
        let visible = document.documentElement.clientHeight
        let bottomOfPage = visible + scrollY >= pageHeight

        return bottomOfPage || pageHeight < visible
      },
      pinActivity (id, val) {
        // Update detail
        if (this.activityDetail && this.activityDetail.id === id) {
          this.activityDetail.saved = val
        }

        // Update result activity
        let savedIndex = this.results.findIndex(obj => obj.id === id)
        if (savedIndex > -1) {
          this.results[savedIndex].saved = val
        }
      },
      removeIntegration (integration) {
        let deleteLink = integration._links.delete

        swal({
          title: 'Are you sure?',
          text: 'Once removed, you will have to reconnect.',
          buttons: true,
          dangerMode: true
        })
        .then((willDelete) => {
          if (willDelete) {
            axios({
              method: deleteLink.method,
              baseURL: deleteLink.href
            })
            .then((response) => {
              integration.connected = false
            })
            .catch((error) => {
              console.log(error)
            })
          }
        })
      },
      searchDebounce: _debounce(function () {
        this.filter('search')
      }, 500),
      scrollMagicFadeIn () {
        if (this.$firefox === false) {
          let fadeElements = document.querySelectorAll('.scrollmagic__fade-in-up')
          let html = document.querySelector('html')

          this.scrollMagicProgress = null

          if (this.$ScrollMagicEvent !== null) {
            for (let fadeElement of fadeElements) {
              let scene = new this.$ScrollMagic.Scene({
                triggerElement: fadeElement,
                triggerHook: 0.9,
                reverse: false
              })
              .setClassToggle(fadeElement, 'scrollmagic__fade-in-up--show')
              // .addIndicators() // Debug tool for scrollmagic

              this.$ScrollMagicEvent.$emit('addScene', 'scrollMagicFadeIn', scene)

              this.scrollMagicProgress = scene.progress()
            }
          }

          if (html.classList.contains('scrollmagic-loading')) {
            html.classList.remove('scrollmagic-loading')
          }
        }
      },
      scrollMagicFadeInDestroy () {
        if (this.$firefox === false) {
          this.$ScrollMagicEvent.$emit('destroy')
        }
      },
      scrollMagicFadeInUpdate () {
        if (this.$firefox === false) {
          let items = this.$el.querySelectorAll('.scrollmagic__fade-in-up')

          if (items.length > 0) {
            this.scrollMagicFadeInDestroy()

            let scrollMagicReady = setInterval(() => {
              this.scrollMagicFadeIn()

              if (this.scrollMagicProgress !== null) {
                clearInterval(scrollMagicReady)
              }
            }, 100)
          }
        }
      },
      scrollToTop () {
        Velocity(document.body, 'scroll', {
          duration: 0,
          offset: 0
        })
      },
      setupIntegration (integration) {
        this.integration = integration
        this.toggleClass('connect-step-active', 'connect-overlay-transition', 500)
      },
      toggleSearch () {
        let html = document.querySelector('html')
        let input = document.querySelector('.activities-search__input')

        if (html.classList.contains(this.searchActiveClass)) {
          this.toggleSearchVisible(false)
        } else {
          this.toggleSearchVisible(true)
        }

        document.onkeydown = (evt) => {
          evt = evt || window.event
          if (evt.keyCode === 27 && input === document.activeElement) {
            this.toggleSearchVisible(false)
          }
        }
      },
      toggleSearchVisible (show = true, resetFilters = true) {
        let html = document.querySelector('html')
        let search = document.querySelector('.activities-search')
        let input = document.querySelector('.activities-search__input')

        html.classList.add('search-toggle')

        if (show) {
          html.classList.add(this.searchActiveClass)
          Velocity(search, { width: '100%' })
          setTimeout(() => { input.focus() }, 100)
        } else {
          html.classList.remove(this.searchActiveClass)
          Velocity(search, { width: 0 })
          this.search = null

          if (resetFilters) {
            this.searchDebounce()
          }
        }

        setTimeout(() => { html.classList.remove('search-toggle') }, 500)
      }
    },
    created () {
      let body = document.querySelector('body')
      let html = document.querySelector('html')

      if (this.$firefox === false) {
        html.classList.add('scrollmagic-loading')
      }

      body.classList.add('gray-background')

      this.platform = 'Shopify'

      if (this.$route.params.id) {
        this.loadActivity(this.$route.params.id)
      }

      this.loadIntegrations()
      this.loadData()
    },
    mounted () {
      let that = this

      // Navigation Tabs
      that.navigationController()

      // IScroll
      that.iScroll()

      // Load
      window.addEventListener('load', () => {
        // IScroll
        that.iScroll()

        // ScrollMagic
        that.$nextTick(that.scrollMagicFadeIn())
      })

      // Resize
      window.addEventListener('resize', () => {
        that.navigationController()
      })

      // Scroll
      window.addEventListener('scroll', () => {
        that.bottom = that.pageBottom()
      })
    },
    watch: {
      bottom: function (boolean) {
        if (boolean === true && this.activitiesNextPage !== null) {
          this.loadData()
        }
      }
    },
    beforeDestroy () {
      let body = document.querySelector('body')

      if (body.classList.contains('gray-background')) {
        body.classList.remove('gray-background')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/pages/Activities.vue